@if (pageReady) {
    <div
        [froalaEditor]="froalaOptions"
        [(froalaModel)]="froalaEditingValue"
        [id]="editorID"
        #editorCmp
    ></div>

    @if (contextMenu) {
        <cerrix-contextmenu [menu]="contextMenu" [container]="editorCmp"></cerrix-contextmenu>
    }

    <div class="modal fade" tabindex="-1" role="dialog" #pdfModal>
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ "pdfSelector.title" | t }}</h5>
                    <button
                        type="button"
                        class="btn-close"
                        data-bs-dismiss="modal"
                        [attr.aria-label]="'pdfSelector.close' | t"
                    ></button>
                </div>
                @if (pdfs) {
                    <div class="modal-body">
                        <div>
                            <table class="table-cerrix bordered rounded centered hoverable striped">
                                <thead>
                                    <tr class="row">
                                        <th class="col-md-4">
                                            {{ "pdfSelector.nameColumn" | t }}
                                        </th>
                                        <th class="col-md-4">
                                            {{ "pdfSelector.descriptionColumn" | t }}
                                        </th>
                                        <th class="col-md-2">
                                            {{ "pdfSelector.uploaderColumn" | t }}
                                        </th>
                                        <th class="col-md-2">
                                            {{ "pdfSelector.dateColumn" | t }}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    @for (data of pdfs; track data) {
                                        <tr
                                            class="row"
                                            (click)="selectedPdf = data"
                                            [ngClass]="{
                                                highlighted:
                                                    selectedPdf != null &&
                                                    selectedPdf.guid == data.guid,
                                            }"
                                        >
                                            <td class="col-md-4">{{ data.name }}</td>
                                            <td class="col-md-4">{{ data.description }}</td>
                                            <td class="col-md-2">{{ data.updatedBy }}</td>
                                            <td class="col-md-2">
                                                {{ data.updatedOn | dateTimeFormat }}
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                }
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                        {{ "pdfSelector.close" | t }}
                    </button>
                    <button
                        type="button"
                        class="btn btn-primary"
                        [disabled]="!selectedPdf"
                        (click)="insertPdf()"
                    >
                        {{ "pdfSelector.insert" | t }}
                    </button>
                </div>
            </div>
        </div>
    </div>
}
